import { REDIRECT_QUERY_PARAM } from "@rshbintech.dboul/http";
import {
  LOGIN_PAGE_PATHNAME,
  MAIN_PAGE_PATHNAME,
  CHOOSE_ORGANIZATION_PATHNAME,
  MINI_LK_PAGE_PATHNAME,
  REDIRECT_ON_APP_STORE_PAGE_PATHNAME,
} from "../app-layout/constants";
import {
  LOGIN_PAGE_PATHNAME_REGEXP,
  MINI_LK_PAGE_PATHNAME_REGEXP,
  CHOOSE_ORGANIZATION_PAGE_PATHNAME_REGEXP,
  REQUIRED_SOFTWARE_PAGE_PATHNAME_REGEXP,
  NSPK_URL_SLUG,
} from "./constants";

export const checkIsLoginPage = () =>
  LOGIN_PAGE_PATHNAME_REGEXP.test(window.location.pathname);

export const checkIsLoginZonePage = () =>
  window.location.pathname.startsWith(LOGIN_PAGE_PATHNAME);

export const checkIsRedirectOnAppStorePage = () =>
  window.location.pathname === REDIRECT_ON_APP_STORE_PAGE_PATHNAME;

export const checkIsMiniLk = () =>
  MINI_LK_PAGE_PATHNAME_REGEXP.test(window.location.pathname);

export const checkIsChooseOrganizationPage = () =>
  CHOOSE_ORGANIZATION_PAGE_PATHNAME_REGEXP.test(window.location.pathname);

export const checkIsRequiredSoftwarePage = () =>
  REQUIRED_SOFTWARE_PAGE_PATHNAME_REGEXP.test(window.location.pathname);

export const redirectToChooseOrganizationPage = () =>
  (window.location.href = CHOOSE_ORGANIZATION_PATHNAME);

export const redirectToMiniLkPage = () =>
  (window.location.href = MINI_LK_PAGE_PATHNAME);

const getQueryParam = (param: string) =>
  new URLSearchParams(window.location.search).get(param);

export const redirectToNextOrMainPage = () => {
  const urlNextParamValue = getQueryParam(REDIRECT_QUERY_PARAM);
  const urlNextParamValueWithoutNSPKSlug = urlNextParamValue?.replace(
    NSPK_URL_SLUG,
    ""
  );

  if (urlNextParamValueWithoutNSPKSlug) {
    window.location.href = urlNextParamValueWithoutNSPKSlug;
  } else {
    window.location.href = MAIN_PAGE_PATHNAME;
  }
};
